import React from 'react'
import request from 'superagent'
import {getColorStyle, timeoutRedirect} from './Util';
import {URL_CANCER} from "../constants/Url";
import {Link} from "react-router-dom";
// import TagManager from 'react-gtm-module';
// import {getTagManagerArgs} from './Util';

export default class Cancer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      category: 1,
      results: []
    }
  }

  handleClickOpen(unit_id){
    const { handleModalOpen } = this.props
    handleModalOpen(unit_id)
  }

  handleClickClose(){
    const { handleModalClose } = this.props
    handleModalClose()
  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    request
      .get(URL_CANCER(this.props.access_token, this.props.gender, this.props.kit))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
        }

        if (!res || !res.body.result) {
          timeoutRedirect()
        }

        this.setState({
          results: res.body.result
        })
      })
  }


  render(){
    // TagManager.initialize(getTagManagerArgs('/cancer'));

    return(
    <div className="wrap">

      <div className="titlearea">
        <h2>がんのリスク評価</h2>
      </div>

      <p className="text_description">Genesis2.0で検査したがんの検査結果を一覧でまとめております。</p>

      <div className="row">
        <div className="col">
          <div className="summary_table">
            <div className="inddata">
              <table>
                <thead>
                  <tr>
                    <th scope="col">検査項目</th>
                    <th colSpan="2" scope="col">検査結果</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.results.map(data =>
                    data && (
                      <tr key={data.id}>
                        <td className="name">{data.unit.name}</td>
                        <td className={`riskrevel ${getColorStyle(data.level_type)}`}>{data.markup_level_name}</td>
                        <td className="detail">
                            <Link to={{
                                pathname: "/detail",
                                state: { referer: "/cancer" }
                            }} ><div className="show_detail" onClick={this.handleClickOpen.bind(this, data.unit.id)}>詳細を見る</div></Link>
                        </td>
                      </tr>))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col">
          <div className="about_canser">
            <h3>がんについて</h3>
            <p className="text_description">日本人の死亡原因の第一位は「がん」です。日本人が生涯のうちにがんに罹患する確率は、男性では63％、女性では47％となっており、2人に1人ががんになる時代です。
早いうちから、がんのことを知り、がんに備え、がんを予防することが大切です。
            </p>
            <p><img src="image/cancer_graph.svg" alt="がんのリスク" /></p>
            <p className="text_description">がんは男女とも50歳代以降に罹患率が上昇し、高齢になるほど高くなる傾向があります。
男女比では30歳代後半から40歳代では女性の罹患率が男性よりやや高く、60歳代以降は男性が女性より顕著に高い傾向があります。（参照：国立がん研究センター　がん情報サービス　最新がん統計（更新日2016年8月2日））
<br/><br/>
早期のがんは自覚症状がほとんどなかったり、他の病気の症状と似ていたりするため、発見が遅れてしまう場合があります。発見が遅れると、治療が難しくなるばかりか、その後の生活の質（QOL）を低下させてしてしまう恐れもあります。
あらかじめ自分の年齢や性別に応じて気を付けるべきがんを知るとともに、遺伝子検査結果を活用して、自分の遺伝的な要因から気を付けるべきがんにも注意を払うようにしましょう。
            </p>
          </div>
        </div>

      </div>

    </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Cancer.js